var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSearchIcon = function SvgSearchIcon(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.738 14.4742L12.8971 11.6324C13.8488 10.4096 14.4215 8.87849 14.4215 7.21287H14.4224C14.4224 3.23531 11.1871 0 7.21074 0C3.23435 0 0 3.23531 0 7.21287C0 11.1895 3.23435 14.4249 7.21074 14.4249C8.87586 14.4249 10.4074 13.852 11.6289 12.9L14.4699 15.7417C14.6446 15.9166 14.8741 16.0044 15.1035 16.0044C15.3329 16.0044 15.5623 15.9166 15.7371 15.7417C16.0875 15.3912 16.0875 14.8247 15.738 14.4742ZM1.79226 7.21279C1.79226 4.22401 4.22272 1.79282 7.21149 1.79282C8.65883 1.79282 10.0201 2.35669 11.0427 3.38045C12.0661 4.4042 12.6289 5.76502 12.6289 7.21279C12.6289 8.70001 12.0258 10.0492 11.0525 11.029C11.0481 11.0335 11.0409 11.0353 11.0364 11.0398C11.0319 11.0442 11.0301 11.0514 11.0257 11.0559C10.0452 12.0294 8.69737 12.6328 7.2097 12.6328C4.22272 12.6319 1.79226 10.2007 1.79226 7.21279Z",
    fill: "white",
    fillOpacity: 0.2
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSearchIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SearchIcon.3026b1d91e1b6d485dca0cd5981d9d7d.svg";